import React, { ReactElement } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import * as Queries from '@api/graphql/queries';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers';
import { adminUpdateProductVariables, adminProduct_adminProducts_data, adminProduct } from '@api/graphql/types';
import { Loading } from '@components/Loading';
import ProductEditForm from '../components/ProductEditForm';

type Props = {
    id?: string,
} & InjectedIntlProps & RouteComponentProps<{ id: string }>;


interface State {
    product?: adminProduct_adminProducts_data;
    notFound: boolean;
}

class ProductEdit extends React.Component<Props, State> {

    private fetchProduct = () => {
        const variables = {
            filters: {
                ext_id: this.props.id,
            },
            count: 1,
            page: 0,
        };

        GraphQLClient.query<adminProduct>({
            query: Queries.adminProduct,
            variables,
        }).then((response) => {
            if (response.data && response.data.adminProducts) {
                if (response.data.adminProducts.data.length === 0) {
                    this.setState({notFound: true});
                    return;
                }
                const product = response.data.adminProducts.data[0];
                this.setState({ product });
            }
        });

    }

    public componentDidMount() {
        this.fetchProduct();
    }

    public onSubmit = (variables: adminUpdateProductVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.adminUpdateProduct, variables,
        });
    }

    private renderForm(): ReactElement<any> {
        if (this.state && this.state.product) {
            return (
                <ProductEditForm product={this.state.product} />
            );
        }

        return <div><Loading /></div>;
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-content">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState, props: Props) => {
    const { id } = props.match.params;
    return { id };
};

export default compose(
    injectIntl,
    withRouter,
    connect(mapStateToProps),
)(ProductEdit);



// WEBPACK FOOTER //
// ./src/modules/Product/pages/ProductEdit.tsx